import { useState, useEffect } from "react";

function useOrientation() {
  const [orientation, setOrientation] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleOrientationChange = () => {
        setOrientation(getOrientation());
      };

      const mediaQuery = window.matchMedia("(orientation: portrait)");
      setOrientation(getOrientation()); // Initial check
      if (mediaQuery)
        mediaQuery.addEventListener("change", handleOrientationChange);

      return () => {
        mediaQuery.removeEventListener("change", handleOrientationChange);
      };
    }
  }, []);

  const getOrientation = () => {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : "landscape";
  };

  return orientation;
}

export default useOrientation;
